<div [ngClass]="barSize === 'large' ? 'bar bar-large' : 'bar'" [ngStyle]="{'background': barColorWithTransparency}">
  <div class="bar-range" [ngStyle]="{'background': barColor, 'left.%': leftValue, 'width.%': widthValue}"></div>
  <div class="bar-value" [ngStyle]="{'left.%': pinPosition}">
    <img src="../../../../../assets/images/bar-pin.png"/>
  </div>
</div>
